<template>
  <div
    class="d-accordion"
    :class="{ 'd-accordion-open': isOpen }"
  >
    <p
      class="d-accordion_question"
      @click="open()"
    >
      <span>
        {{ question }}
      </span>
      <transition name="rotate">
        <span
          class="d-accordion_arrow"
          :class="isOpen ? 'd-accordion_arrow-open' : 'd-accordion_arrow-close'"
        ></span>
      </transition>
    </p>
    <transition name="open">
      <div
        class="d-accordion_answer"
        v-show="isOpen"
        v-html="answer"
      >
      </div>
    </transition>
  </div>
</template>
<script>
/** @type {import('vue').ComponentOptions} */
const dAccordion = {
  name: 'DAccordion',
  props: {
    question: {
      type: String,
      required: true
    },
    answer: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isOpen: false
    }
  },
  methods: {
    open() {
      this.isOpen = !this.isOpen
    }
  }
}
export default dAccordion
</script>
<style lang="scss" scoped>
.d-accordion {
  margin: 0 auto 34px;
  border-bottom: 1px solid $ds2-color-gray-200;
  &-open {
    padding-bottom: 16px;
  }
  &_question {
    @include link-effect;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 18px;
    margin-bottom: 0;
    color: $ds2-color-gray-700;
    font-weight: bold;
    font-size: 15px;
    cursor: pointer;
  }
  &_arrow {
    display: inline-block;
    right: 0;
    width: 12px;
    height: 12px;
    border: 2px solid $ds2-color-brand-primary;
    transform: rotate(-45deg);
    padding-left: 6px;
    &-open {
      margin-top: 6px;
      border-color: $ds2-color-brand-primary $ds2-color-brand-primary transparent transparent;
    }
    &-close {
      margin-bottom: 8px;
      border-color: transparent transparent $ds2-color-brand-primary $ds2-color-brand-primary;
    }
  }
  &_answer {
    font-size: 15px;
    color: $ds2-color-gray-700;
  }
}

@keyframes open {
  0% {
    opacity: 0;
    transform: translateY(-5px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.open-enter-active {
  animation: open 0.5s;
}

.open-leave-active {
  animation: open 0.2s linear reverse;
}

.rotate-enter-active {
  animation: rotate 0.5s linear;
}

@media (max-width: breakpoint(BusinessTop, S)) {
  .d-accordion {
    margin: 0 auto 24px;
  }
}
</style>
